module.exports = __webpack_public_path__ + "assets/img/00194.4b1fad96.png";